/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Workout_Correct_TitleInputs */

const en_us2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correct set ${i?.n}`)
};

const pt_br2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrigir série ${i?.n}`)
};

const es_419_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corregir serie ${i?.n}`)
};

const pt_pt2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrigir série ${i?.n}`)
};

const fr_fr2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corriger la série ${i?.n}`)
};

const de_de2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Satz ${i?.n} korrigieren`)
};

const it_it2_workout_correct_title = /** @type {(inputs: Workout_Correct_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correggi serie ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Correct set {n}" |
*
* @param {Workout_Correct_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_correct_title = /** @type {((inputs: Workout_Correct_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Correct_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_correct_title(inputs)
	if (locale === "es-419") return es_419_workout_correct_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_correct_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_correct_title(inputs)
	if (locale === "de-DE") return de_de2_workout_correct_title(inputs)
	if (locale === "it-IT") return it_it2_workout_correct_title(inputs)
	return en_us2_workout_correct_title(inputs)
});
export { workout_correct_title as "workout.correct_title" }